/* eslint-disable jira/filename-case */
import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages';

export function AddPeopleGraphic() {
	const { formatMessage } = useIntl();
	return (
		<svg
			width="366"
			height="276"
			viewBox="0 0 366 276"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<rect
				width="200"
				height="244"
				transform="matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)"
				fill="#1868DB"
			/>
			<rect
				x="172.24"
				y="13.9958"
				width="193"
				height="243"
				transform="rotate(1.512 172.24 13.9958)"
				fill="#FCA700"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z"
				fill="#09326C"
			/>
			<g clipPath="url(#clip0_1210_8269)">
				<rect width="284" height="185" transform="translate(41 40.5)" fill="white" />
				<rect width="284" height="56" transform="translate(41 40.5)" fill="white" />
				<g clipPath="url(#clip1_1210_8269)">
					<g clipPath="url(#clip2_1210_8269)">
						<g clipPath="url(#clip3_1210_8269)">
							<g clipPath="url(#clip4_1210_8269)">
								<path
									d="M78.3264 71.5201C73.3886 69.1325 71.9461 68.7757 69.8656 68.7757C67.4244 68.7757 65.3439 69.7911 63.4853 72.6452L63.1801 73.1118C62.9305 73.496 62.875 73.6332 62.875 73.7979C62.875 73.9625 62.9582 74.0997 63.2634 74.2919L66.398 76.2403C66.5645 76.3501 66.7032 76.405 66.8419 76.405C67.0083 76.405 67.1193 76.3227 67.2857 76.0757L67.785 75.3073C68.5618 74.1272 69.2553 73.743 70.143 73.743C70.9197 73.743 71.8351 73.9625 72.9725 74.5114L76.2459 76.0482C76.5787 76.2129 76.9394 76.1306 77.1058 75.7464L78.6593 72.3434C78.8257 71.9592 78.7147 71.7122 78.3264 71.5201ZM63.9291 65.5099C68.8669 67.8975 70.3094 68.2543 72.3899 68.2543C74.8311 68.2543 76.9116 67.2389 78.7702 64.3848L79.0754 63.9182C79.325 63.534 79.3805 63.3968 79.3805 63.2321C79.3805 63.0675 79.2973 62.9303 78.9922 62.7381L75.8575 60.7897C75.691 60.6799 75.5523 60.625 75.4136 60.625C75.2472 60.625 75.1362 60.7073 74.9698 60.9543L74.4705 61.7227C73.6937 62.9028 73.0002 63.287 72.1125 63.287C71.3358 63.287 70.4204 63.0675 69.283 62.5186L66.0097 60.9818C65.6768 60.8171 65.3162 60.8994 65.1497 61.2836L63.5962 64.6866C63.4298 65.0708 63.5408 65.3178 63.9291 65.5099Z"
									fill="#1868DB"
								/>
							</g>
						</g>
					</g>
					<text
						fill="#172B4D"
						xmlSpace="preserve"
						// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
						style={{ whiteSpace: 'pre' }}
						fontSize="16"
						fontWeight="590"
						letterSpacing="0px"
					>
						<tspan x="91" y="74.1875">
							{formatMessage(messages.addPeopleSvgText)}
						</tspan>
					</text>
				</g>
				<rect x="52" y="97" width="258" height="74" fill="white" />
				<rect x="52" y="97" width="258" height="74" stroke="#DDDEE1" stroke-width="2" />
				<rect x="61" y="106" width="88" height="24" rx="12" fill="#F1F2F4" />
				<circle cx="73" cy="118" r="8" fill="url(#pattern0_1210_8269)" />
				<rect
					width="45.3333"
					height="8"
					rx="4"
					transform="matrix(1 0 0 -1 85 122)"
					fill="#DDDEE1"
				/>
				<path
					d="M139.666 117.372L137.314 115.019C137.23 114.938 137.118 114.893 137.001 114.894C136.885 114.895 136.773 114.942 136.691 115.025C136.608 115.107 136.562 115.218 136.561 115.335C136.56 115.451 136.604 115.564 136.685 115.648L139.038 118L136.685 120.352C136.604 120.436 136.56 120.549 136.561 120.665C136.562 120.782 136.608 120.893 136.691 120.976C136.773 121.058 136.885 121.105 137.001 121.106C137.118 121.107 137.23 121.062 137.314 120.981L139.666 118.628L142.019 120.981C142.102 121.062 142.215 121.107 142.331 121.106C142.448 121.105 142.559 121.058 142.642 120.976C142.724 120.893 142.771 120.782 142.772 120.665C142.773 120.549 142.728 120.436 142.647 120.352L140.295 118L142.647 115.648C142.69 115.607 142.723 115.558 142.747 115.503C142.77 115.449 142.782 115.391 142.783 115.332C142.783 115.273 142.772 115.214 142.75 115.16C142.727 115.105 142.694 115.055 142.653 115.014C142.611 114.972 142.561 114.939 142.507 114.917C142.452 114.894 142.393 114.883 142.334 114.883C142.275 114.884 142.217 114.896 142.163 114.92C142.109 114.943 142.06 114.977 142.019 115.019L139.666 117.372Z"
					fill="#44546F"
				/>
				<rect x="161" y="106" width="81.3333" height="24" rx="12" fill="#F1F2F4" />
				<circle cx="173" cy="118" r="8" fill="url(#pattern1_1210_8269)" />
				<rect
					width="38.6667"
					height="8"
					rx="4"
					transform="matrix(1 0 0 -1 185 122)"
					fill="#DDDEE1"
				/>
				<path
					d="M233 117.372L230.648 115.019C230.564 114.938 230.452 114.893 230.335 114.894C230.219 114.895 230.107 114.942 230.025 115.025C229.942 115.107 229.896 115.218 229.895 115.335C229.894 115.451 229.938 115.564 230.019 115.648L232.372 118L230.019 120.352C229.938 120.436 229.894 120.549 229.895 120.665C229.896 120.782 229.942 120.893 230.025 120.976C230.107 121.058 230.219 121.105 230.335 121.106C230.452 121.107 230.564 121.062 230.648 120.981L233 118.628L235.353 120.981C235.436 121.062 235.549 121.107 235.665 121.106C235.782 121.105 235.893 121.058 235.976 120.976C236.058 120.893 236.105 120.782 236.106 120.665C236.107 120.549 236.062 120.436 235.981 120.352L233.629 118L235.981 115.648C236.024 115.607 236.057 115.558 236.081 115.503C236.104 115.449 236.116 115.391 236.117 115.332C236.117 115.273 236.106 115.214 236.084 115.16C236.061 115.105 236.028 115.055 235.987 115.014C235.945 114.972 235.895 114.939 235.841 114.917C235.786 114.894 235.727 114.883 235.668 114.883C235.609 114.884 235.551 114.896 235.497 114.92C235.443 114.943 235.394 114.977 235.353 115.019L233 117.372Z"
					fill="#44546F"
				/>
				<rect x="61" y="138" width="88" height="24" rx="12" fill="#F1F2F4" />
				<circle cx="73" cy="150" r="8" fill="url(#pattern2_1210_8269)" />
				<rect
					width="45.3333"
					height="8"
					rx="4"
					transform="matrix(1 0 0 -1 85 154)"
					fill="#DDDEE1"
				/>
				<path
					d="M139.666 149.372L137.314 147.019C137.23 146.938 137.118 146.893 137.001 146.894C136.885 146.895 136.773 146.942 136.691 147.025C136.608 147.107 136.562 147.218 136.561 147.335C136.56 147.451 136.604 147.564 136.685 147.648L139.038 150L136.685 152.352C136.604 152.436 136.56 152.549 136.561 152.665C136.562 152.782 136.608 152.893 136.691 152.976C136.773 153.058 136.885 153.105 137.001 153.106C137.118 153.107 137.23 153.062 137.314 152.981L139.666 150.628L142.019 152.981C142.102 153.062 142.215 153.107 142.331 153.106C142.448 153.105 142.559 153.058 142.642 152.976C142.724 152.893 142.771 152.782 142.772 152.665C142.773 152.549 142.728 152.436 142.647 152.352L140.295 150L142.647 147.648C142.69 147.607 142.723 147.558 142.747 147.503C142.77 147.449 142.782 147.391 142.783 147.332C142.783 147.273 142.772 147.214 142.75 147.16C142.727 147.105 142.694 147.055 142.653 147.014C142.611 146.972 142.561 146.939 142.507 146.917C142.452 146.894 142.393 146.883 142.334 146.883C142.275 146.884 142.217 146.896 142.163 146.92C142.109 146.943 142.06 146.977 142.019 147.019L139.666 149.372Z"
					fill="#44546F"
				/>
				<rect x="261" y="188" width="50" height="22" fill="#1868DB" />
			</g>
			<defs>
				<pattern
					id="pattern0_1210_8269"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use xlinkHref="#image0_1210_8269" transform="scale(0.0025)" />
				</pattern>
				<pattern
					id="pattern1_1210_8269"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use xlinkHref="#image1_1210_8269" transform="scale(0.0025)" />
				</pattern>
				<pattern
					id="pattern2_1210_8269"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use xlinkHref="#image2_1210_8269" transform="scale(0.0025)" />
				</pattern>
				<clipPath id="clip0_1210_8269">
					<rect width="284" height="185" fill="white" transform="translate(41 40.5)" />
				</clipPath>
				<clipPath id="clip1_1210_8269">
					<rect width="236" height="24" fill="white" transform="translate(59 56.5)" />
				</clipPath>
				<clipPath id="clip2_1210_8269">
					<rect width="24" height="24" fill="white" transform="translate(59 56.5)" />
				</clipPath>
				<clipPath id="clip3_1210_8269">
					<rect width="24" height="24" fill="white" transform="translate(59 56.5)" />
				</clipPath>
				<clipPath id="clip4_1210_8269">
					<rect width="16.5055" height="15.78" fill="white" transform="translate(62.875 60.625)" />
				</clipPath>
			</defs>
		</svg>
	);
}
